import {AnalyticsEventHandler} from "../../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../../third-party-services/analytics/analytics-service";
import {COMPETITOR_PLAYER_STATS} from "../../competitor-players-stats-module.consts";
import {CompetitorPlayersStatsModuleState} from "../../models/competitor-players-stats-module.state";
import {CompetitorPlayersStatsModuleController} from "../../competitor-players-stats-module.controller";
import {CompetitorPlayerStatsModuleStatsButtonClickEvent} from "../../models/analytics/competitor-player-stats-module.stats-button.click.event";

export class CompetitorPlayerStatsModuleButtonClickEventHandler extends AnalyticsEventHandler {
  type = COMPETITOR_PLAYER_STATS.ACTION_TYPES.onButtonClick;
  state: CompetitorPlayersStatsModuleState;
  controller: CompetitorPlayersStatsModuleController;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = CompetitorPlayerStatsModuleStatsButtonClickEvent;
  }
}
